import { render, staticRenderFns } from "./wxtongueresult.vue?vue&type=template&id=1956467b&scoped=true&"
import script from "./wxtongueresult.vue?vue&type=script&lang=js&"
export * from "./wxtongueresult.vue?vue&type=script&lang=js&"
import style0 from "./wxtongueresult.vue?vue&type=style&index=0&id=1956467b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956467b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1956467b')) {
      api.createRecord('1956467b', component.options)
    } else {
      api.reload('1956467b', component.options)
    }
    module.hot.accept("./wxtongueresult.vue?vue&type=template&id=1956467b&scoped=true&", function () {
      api.rerender('1956467b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxtongueresult.vue"
export default component.exports